"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceTypeToJSON = exports.VoiceTypeFromJSONTyped = exports.VoiceTypeFromJSON = exports.VoiceType = void 0;
/**
 *
 * @export
 */
exports.VoiceType = {
    MIDDLEAGEFEMALE: 'middleAgeFemale',
    MIDDLEAGEMALE: 'middleAgeMale',
    SENIORFEMALE: 'seniorFemale',
    SENIORMALE: 'seniorMale',
    TEENAGEBOY: 'teenageBoy',
    TEENAGEGIRL: 'teenageGirl',
    YOUNGADULTFEMALE: 'youngAdultFemale',
    YOUNGADULTMALE: 'youngAdultMale'
};
function VoiceTypeFromJSON(json) {
    return VoiceTypeFromJSONTyped(json, false);
}
exports.VoiceTypeFromJSON = VoiceTypeFromJSON;
function VoiceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.VoiceTypeFromJSONTyped = VoiceTypeFromJSONTyped;
function VoiceTypeToJSON(value) {
    return value;
}
exports.VoiceTypeToJSON = VoiceTypeToJSON;
